<template>
  <x-page title="全部评价" :loading="loading" :white-background="true">
    <div v-if="!loading" class="evaluation-list">
      <ul class="title">
        <li
          v-track="{
            name: '全部评论-全部',
            id: 'cbcca5de-1213-44ec-a0a6-41ed35c77aa9',
          }"
          :class="{ active: !havingPicFlag && labelId === null }"
          @click="filterChange(false, null)"
        >
          全部
        </li>
        <li
          v-track="{
            name: '全部评论-有图',
            id: 'c6d4ecc4-5ab1-4881-bef0-86b7c2b14b4f',
          }"
          :class="{ active: havingPicFlag }"
          @click="filterChange(true, null)"
        >
          有图({{ number }})
        </li>
        <li
          v-for="(item, index) in labelList"
          :key="index"
          v-track="{
            name: '全部评论-标签',
            id: '42d2b022-a93f-45e3-b248-5590041b4de3',
            content: item.labelContent,
          }"
          :class="{ active: labelId === item.labelId }"
          @click="filterChange(false, item.labelId, item.labelContent)"
        >
          {{ item.labelContent }}
        </li>
      </ul>
      <div class="ribbon"></div>

      <x-waterfall ref="list" :load="load">
        <template #default="{ data }">
          <com-evaluation-item
            v-for="item in data"
            :key="item.id"
            class="list-item van-hairline--bottom"
            :item="item"
          />
        </template>
      </x-waterfall>
    </div>
  </x-page>
</template>

<script>
  import ComEvaluationItem from './components/comment'
  import {
    apiEvaluationEvaluateCountEvaluateHavingPic,
    apiEvaluationEvaluateGetLabelList,
    apiEvaluationEvaluateList,
  } from '@/api'
  import { prepareData, Track } from '@/utils'

  export default {
    noKeepalive: true,
    components: { ComEvaluationItem },
    mixins: [
      Track.provideMark(() => ({
        page: '全部评价',
      })),
    ],
    data() {
      return {
        labelList: [],
        loading: true,
        havingPicFlag: false,
        labelId: null,
        labelContent: '',
        number: 0,
      }
    },
    async created() {
      const { picCommentCount, labelList } = await prepareData({
        picCommentCount: apiEvaluationEvaluateCountEvaluateHavingPic({
          commodityServiceId: this.$route.query.id,
        }),
        labelList: apiEvaluationEvaluateGetLabelList({
          commodityServiceId: this.$route.query.id,
        }),
      })
      this.number = picCommentCount
      this.labelList = labelList || []
      this.loading = false
    },
    methods: {
      filterChange(havingPicFlag, labelId, labelContent) {
        this.havingPicFlag = havingPicFlag
        this.labelId = labelId
        this.labelContent = labelContent
        this.$reloadWaterfall('list')
      },
      load({ pageNumber }) {
        return apiEvaluationEvaluateList({
          commodityServiceId: this.$route.query.id,
          pageIndex: pageNumber,
          pageSize: 15,
          havingPicFlag: this.havingPicFlag,
          labelId: this.labelId,
          labelContent: this.labelContent,
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .evaluation-list {
    background: #ffffff;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    > .title {
      display: flex;
      flex-wrap: wrap;
      padding-top: 15px;
      padding-left: 13px;
      padding-bottom: 9px;
      background-color: white;

      position: sticky;
      top: 0;
      z-index: 9;

      li {
        height: 24px;
        background: #f5f6f8;
        border-radius: 12px;

        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 24px;
        padding: 0 10px;
        margin-right: 8px;
        margin-bottom: 8px;

        &.active {
          color: #ff111c;
          background: #fff2f1;
        }
      }
    }

    > .ribbon {
      position: relative;
      height: 10px;
      background: #eeeeee;
      z-index: 8;
    }

    .list-item {
      padding: 15px 12px 18px;

      &:after {
        margin-left: 24px;
        margin-right: 24px;
      }

      ::v-deep .evaluation-item-user {
        margin-top: 0;
      }
    }

    .van-list {
      min-height: calc(100vh - var(--nav-bar-height) - 67px);
    }
  }
</style>
